import {InitThumbnails, showThumbnails} from './thumbnails';

let articleIndex = 3;
const ARTICLES_INCREMENT = 6;

export function InitNews() {
	const newsContainer = document.querySelector('.news-container');
	if (newsContainer === null || newsContainer.classList.contains('preview')) return;
	const newsThumbnails = newsContainer.querySelectorAll('.news-container > .card');

	if (newsThumbnails.length === 0)	{
		const buttonLoadMore = document.querySelector('.bard__module.news .button-primary');
		if (buttonLoadMore === null)	return;
		buttonLoadMore.style.display = 'none';
		return;
	}

	InitThumbnails(newsThumbnails, 3);

	InitLoadMore(newsThumbnails);
}

function InitLoadMore(newsThumbnails) {
	const buttonLoadMore = document.querySelector('.bard__module.news .button-primary');

	if (buttonLoadMore === null)
		return;

	if (articleIndex > newsThumbnails.length)
		buttonLoadMore.style.display = 'none';

	buttonLoadMore.addEventListener('click', () => {
		showThumbnails(newsThumbnails, articleIndex, ARTICLES_INCREMENT);
		articleIndex += ARTICLES_INCREMENT;

		if (articleIndex > newsThumbnails.length)
			buttonLoadMore.style.display = 'none';
	});
}
